function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Dosya okunamadı."));
    reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Görsel yüklenemedi."));
    image.src = src;
  });
}

function fitSize(width, height, maxWidth, maxHeight) {
  if (!width || !height) {
    return { width: maxWidth, height: maxHeight };
  }

  const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
  return {
    width: Math.max(1, Math.round(width * ratio)),
    height: Math.max(1, Math.round(height * ratio)),
  };
}

export async function resizeImageFileToDataUrl(
  file,
  {
    maxWidth = 1280,
    maxHeight = 1280,
    quality = 0.82,
    outputType = "image/jpeg",
    maxDataUrlLength = 2_400_000,
  } = {}
) {
  if (!file) return "";

  if (!String(file.type || "").startsWith("image/")) {
    throw new Error("Lütfen geçerli bir görsel seçin.");
  }

  const sourceDataUrl = await readFileAsDataUrl(file);
  const image = await loadImage(sourceDataUrl);
  const naturalWidth = image.naturalWidth || image.width;
  const naturalHeight = image.naturalHeight || image.height;
  const target = fitSize(naturalWidth, naturalHeight, maxWidth, maxHeight);

  const canvas = document.createElement("canvas");
  let outputWidth = target.width;
  let outputHeight = target.height;
  let outputQuality = quality;
  let result = "";

  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Görsel işleme başlatılamadı.");
  }

  // Dört fotoğraflı tek isteğin sunucu gövde sınırını aşmaması için kalite ve
  // çözünürlük kontrollü biçimde küçültülür; özgün dosya çevrimdışı kuyruğa girmez.
  for (let attempt = 0; attempt < 10; attempt += 1) {
    canvas.width = outputWidth;
    canvas.height = outputHeight;
    context.clearRect(0, 0, outputWidth, outputHeight);
    context.drawImage(image, 0, 0, outputWidth, outputHeight);
    result = canvas.toDataURL(outputType, outputQuality);
    if (result.length <= maxDataUrlLength) break;

    if (outputQuality > 0.55) {
      outputQuality = Math.max(0.55, outputQuality - 0.08);
    } else {
      outputWidth = Math.max(480, Math.round(outputWidth * 0.82));
      outputHeight = Math.max(480, Math.round(outputHeight * 0.82));
    }
  }

  if (!result.startsWith("data:image/")) {
    throw new Error("Görsel dönüştürülemedi.");
  }

  if (result.length > maxDataUrlLength) {
    throw new Error("Fotoğraf çok büyük, lütfen daha küçük bir görsel deneyin.");
  }

  return result;
}
